// extracted by mini-css-extract-plugin
module.exports = {"page":"page__3iNHMpJ6R6bTl","header":"header__j0J8Nj2zcryiG","label":"label__uGLe4KTK3QLKM"};